import "../styles/FAQSection.css";
import TextField from "@material-ui/core/TextField/TextField";
import Paper from "@mui/material/Paper/Paper";
import { useEffect, useState } from "react";
import { Accordion } from "../components/Certification/Accordion";
import { AccordionSummary } from "../components/Certification/AccordionSummary";
import { AppToolbar } from "../components/AppToolbar";
import { ColorUtils } from "../utils/ColorUtils";
import { FAQAccordionDetails } from "../components/FAQSection/FAQAccordionDetails";
import useDebounce from "../external/ensolvers-core-frontend-mui/hooks/useDebounce";
import FAQService from "../services/FAQService";
import FAQs from "../models/FAQs";
import { traceo } from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/Logging";
import { ROWS_PER_PAGE } from "../App";
import { SpinnerWrapper } from "../components/SpinnerWrapper";
import { useLocation } from "react-router-dom";
import { Routes } from "../types/Routes";
import useUpdateUrl from "../hooks/useUpdateUrl";

export default function FAQSection() {
  const [searchQuestion, setSearchQuestion] = useState<string>("");
  const searchTerm = useDebounce(searchQuestion, 100);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [expanded, setExpanded] = useState<string | false>("");
  const [question, setQuestion] = useState<FAQs[]>([]);
  const searchParams = new URLSearchParams(useLocation().search);
  const title = searchParams.get("title");
  const {updateUrl} = useUpdateUrl(Routes.FAQS, searchParams);

  useEffect(() => {
    if (title !== null && title !== "") {
      setSearchQuestion(title);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setIsLoading(true);
    const delayDebounceFn = setTimeout(() => {
      getQuestionByFilter(searchQuestion);
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  const handleChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };

  const getQuestionByFilter = (querysearchQuestion: string) => {
    FAQService.findFAQsFilter(0, ROWS_PER_PAGE, searchQuestion)
      .then((r) => setQuestion(r.getContentOrThrowError().content))
      .catch((error) => traceo("Frequent Asked Questions.", error, null));
  };

  return (
    <>
      <AppToolbar title="FAQ Section">
        <TextField
          label="Search by title"
          value={searchQuestion}
          onChange={(e) => {
            setSearchQuestion(e.target.value);
            searchParams.set("title", e.target.value);
            updateUrl();
          }}
          autoComplete="off"
          fullWidth
          autoFocus
          variant="outlined"
          size="small"
        />
      </AppToolbar>
      <SpinnerWrapper isLoading={isLoading}>
        <Paper>
          {question.map((quest) => (
            <Accordion
              expanded={expanded === `panel${quest.externalId}`}
              onChange={handleChange(`panel${quest.externalId}`)}
              key={quest.externalId}
              TransitionProps={{ unmountOnExit: true }}
            >
              <AccordionSummary
                title={quest.title}
                sx={{
                  backgroundColor: ColorUtils.LIGHT_YELLOW,
                  "&:hover": {
                    backgroundColor: ColorUtils.ENSOLVERS_ORANGE_REBRANDING,
                  },
                }}
              />
              <FAQAccordionDetails question={quest.description} />
            </Accordion>
          ))}
        </Paper>
      </SpinnerWrapper>
    </>
  );
}
